<template>
  <v-container class="main-container d-flex flex-column justify-center">
    <div class="my-9">
      <!-- TEXT -->
      <v-row class="align-content-end">
        <v-col cols="12" md="10" offset="0" offset-md="1" class="pt-0">
          <div class="text-left text-label--big text-justify">
            {{ $t("upload_info") }}
          </div>
          <v-divider class="mt-5"></v-divider>
        </v-col>
      </v-row>

      <!-- FILE UPLOAD -->
      <v-form v-model="filesValid">
        <v-container v-for="type in requiredResources" :key="type.id">
          <v-row no-gutters class="">
            <v-col cols="12" md="9" offset-md="1" align="left" class="mb-2" aria-hidden="true">
              <component slot="label" class="text-label" :is="convertLink(type.title[locale])"></component>
              <span class="text-optional" v-if="type.mandatory">{{ $t("required") }}</span>
              <span class="text-optional" v-if="!type.mandatory">{{ $t("optional") }}</span>
            </v-col>
          </v-row>
          <v-row v-for="(doc, index) in documents[type.id]" :key="`file-${index}`">
            <v-col cols="11" md="9" offset-md="1" align="left">
              <v-file-input
                :color="uiColor"
                solo
                show-size
                v-model="documents[type.id][index].file"
                class="input-margin"
                @change="deleteEmptyFile(type.id, type.multiple)"
                :accept="type.allowedType"
                :rules="[rules.fileSize(type.maxFileSize, documents[type.id][index].file)]"
                :label="$t('upload_label')"
                prepend-icon="$vuetify.icons.paperclip"
                :aria-label="`${type.title[locale]} ${type.mandatory ? $t('required') : $t('optional')}`"
              ></v-file-input>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </div>
    <!-- Navigation Buttons -->
    <div>
      <v-btn
        tile
        :color="uiColor"
        class="next-button"
        :disabled="!filesValid"
        v-on:click="$emit('next-button-clicked')"
        data-test="button-next"
        >{{ $t("proceed") }}</v-btn
      >
      <v-btn tile :color="uiColor" class="back-button" v-on:click="$emit('back-button-clicked')">{{
        $t("back")
      }}</v-btn>
    </div>
  </v-container>
</template>

<script>
import { convertLink } from "../utils/utils";

export default {
  name: "DocumentUpload",
  components: {},
  data() {
    return {
      locale: this.$store.getters["registration/locale"],
      requiredResources: this.$store.getters["registration/requiredResources"],
      lockSubmit: false,
      random: this.$store.getters["registration/registrationRandom"],
      tenant: this.$store.getters["registration/tenant"],
      filesValid: true,
      uiColor: this.$store.getters["registration/uiColor"],
      rules: {
        fileSize(max, value) {
          return !value || value.size < max || "File too big";
        },
      },
    };
  },
  methods: {
    convertLink,
    deleteEmptyFile(id, multiple) {
      this.documents[id] = this.documents[id].filter((file) => file.file != null);
      if (this.documents[id].length === 0 || multiple) {
        this.documents[id].push({
          file: null,
          uploadStatus: null,
        });
      }
    },
  },
  computed: {
    documents: {
      get() {
        return this.$store.getters["registration/documents"];
      },
      set(value) {
        this.$store.dispatch("registration/updateDocuments", value);
      },
    },
  },
};
</script>

<style scoped>
.main-container {
  height: 100%;
}
.text-margin {
  margin-bottom: 24px;
}
.v-text-field.v-text-field--enclosed .v-text-field__details {
  height: 0;
  padding: 0;
  margin: 0;
}
.input-margin {
  margin-bottom: -32px !important;
}
@media (max-width: 960px) {
  .align--right {
    text-align: left !important;
  }
  .main-container {
    height: fit-content !important;
  }
  .text-margin {
    margin-bottom: 12px;
  }
  .dropdown {
    margin-bottom: -12px;
  }
}
.align--right {
  text-align: right;
}
.input-error ::v-deep .v-input__slot {
  box-shadow: 0px 3px 1px -2px rgba(240, 64, 79, 0.2), 0px 2px 2px 0px rgba(240, 64, 79, 0.2),
    0px 1px 5px 0px rgba(240, 64, 79, 0.2) !important;
}
.input-error-checkbox ::v-deep i {
  color: rgba(240, 64, 79, 0.8);
}
.select.focused ::v-deep .v-input__slot {
  box-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14),
    0px 1px 18px 0px rgba(0, 0, 0, 0.12) !important;
}
.select-cursor ::v-deep input {
  cursor: pointer !important;
}
.select-cursor ::v-deep .v-input__slot {
  cursor: pointer !important;
}
</style>
